<div class="dateRange" *ngIf="dateRangePickerOptions">
  <span class="interval">{{ 'settings.interval' | translate }}</span>
  <label class="btn-S btn-text icon-end" for="apiDateRangePickerLabel" #dateRangePickerLabel>
    <input
      #dateRange
      id="apiDateRangePickerLabel"
      type="text"
      class="btn-S btn-text"
      ngxDaterangepickerMd
      opens="center"
      [(ngModel)]="selectedDateRange"
      [ngModelOptions]="{ standalone: true }"
      [class.empty]="!(selectedDateRange && (selectedDateRange.startDate || selectedDateRange.endDate))"
      [keepCalendarOpeningWithRange]="true"
      [alwaysShowCalendars]="true"
      [showCustomRangeLabel]="true"
      [locale]="dateRangePickerOptions.locale"
      [ranges]="dateRangePickerOptions.ranges"
      (datesUpdated)="organizationApiUsage()"
      (startDateChanged)="allowApplyOnlyWhenStartAndEndDateExists(false)"
      (endDateChanged)="allowApplyOnlyWhenStartAndEndDateExists(true)"
      readonly
    />
    <i class="fa-solid fa-caret-down"></i>
  </label>
</div>

<div class="card__container">
  <div class="card__item">
    <p class="card__title">{{ 'settings.total_cost' | translate }}</p>
    <p class="card__value">
      {{ getRealCost(summary?.totalCost) | lcurrency: currencyCode }}
      <span class="monster__badge badge-M badge-neutral" [ngbTooltip]="summaryTotalCostTooltip" container="body" placement="right">
        {{ summary?.totalCost || 0 | lcurrency: ' ' }} - {{ (currencyCode === 'R$' ? '99.00' : '19.00') | lcurrency: ' ' }}
        <i class="fa-solid fa-circle-info"></i>
      </span>
    </p>
    <!--    <p class="card__change positive">↑ 2%</p>-->
  </div>

  <div class="card__item">
    <p class="card__title">{{ 'settings.created_documents' | translate }}</p>
    <p class="card__value">{{ (summary?.seriesSummary)[ApiUsagePriority.CreateDocument]?.totalValue || 0 }}</p>
    <!--    <p class="card__change negative">↓ 12%</p>-->
  </div>

  <div class="card__item">
    <p class="card__title">{{ 'settings.avg_cost_per_doc' | translate }}</p>
    <p class="card__value">{{ summary?.totalCost / (summary?.seriesSummary)[ApiUsagePriority.CreateDocument]?.totalValue || 0 | lcurrency: currencyCode }}</p>
    <!--    <p class="card__change positive">↑ 72%</p>-->
  </div>
</div>

<div class="chart__header">
  <div class="chart__controls">
    <a class="btn-S btn-text icon-start" (click)="openApiUsageLimitsModal()">
      <i class="fa-regular fa-bell"></i>
      {{ 'settings.setApiUsageLimits' | translate }}
    </a>
    <app-switch-tabs
      name="type"
      [options]="[
        [false, translateService.instant('settings.consume')],
        [true, translateService.instant('settings.price')]
      ]"
      [(ngModel)]="isShowingCost"
      (ngModelChange)="toggleChartData()"
      [ngModelOptions]="{ standalone: true }"
    ></app-switch-tabs>
  </div>
</div>

<div class="chart__container" *ngIf="view">
  <ngx-charts-bar-vertical-stacked
    *ngIf="resultsLineChartData && !isLoading"
    [view]="view"
    [scheme]="colorScheme"
    [animations]="true"
    [xAxis]="true"
    [xAxisTickFormatting]="formatXAxisTicks"
    [yAxis]="true"
    [yAxisTickFormatting]="formatYAxisTicks"
    [rotateXAxisTicks]="false"
    [results]="resultsLineChartData"
  >
    <ng-template #tooltipTemplate let-model="model">
      <div class="customTooltip">
        <div class="customTooltip__item">
          <span class="customTooltip__name left-align">
            <strong>{{ getDate(model) | ldate: 'mediumDate' }}</strong>
            <ng-container *ngIf="getNextDate(model)">
              {{ 'settings.to' | translate }}
              <strong>{{ getNextDate(model) | ldate: 'mediumDate' }}</strong>
            </ng-container>
          </span>
        </div>
        <div class="customTooltip__item" *ngFor="let entry of getTooltipData(model)" [class.selected]="model.name === entry.name">
          <span class="customTooltip__name left-align"
            ><span class="customTooltip__color" [style.background-color]="getColorByCategory(entry.name)"></span>{{ 'settings.apiUsageItems.' + entry.name | translate }}</span
          >
          <span class="customTooltip__value right-align">{{ entry.usage }}</span>
          <span class="customTooltip__cost right-align">{{ entry.cost | lcurrency: currencyCode }}</span>
        </div>
        <div class="customTooltip__item">
          <span class="customTooltip__name left-align"></span>
          <span class="customTooltip__value right-align"
            ><strong>{{ 'settings.total' | translate }}</strong></span
          >
          <span class="customTooltip__cost right-align"
            ><strong>{{ getTotalCost(model) | lcurrency: currencyCode }}</strong></span
          >
        </div>
      </div>
    </ng-template>
  </ngx-charts-bar-vertical-stacked>
</div>

<div class="configuration-item"></div>

<div class="summary__container">
  <div class="summary__header">
    <span class="summary__title summary__name">{{ 'settings.category' | translate }}</span>
    <span class="summary__title summary__value">{{ 'settings.consume' | translate }}</span>
    <span class="summary__title summary__cost">{{ 'settings.price' | translate }}&nbsp;({{ currency }})</span>
  </div>

  <div class="summary__item" *ngFor="let item of summary.seriesSummary">
    <span class="summary__name"><span class="summary__color" [style.background-color]="getColorByCategory(item.name)"></span>{{ 'settings.apiUsageItems.' + item.name | translate }}</span>
    <span class="summary__value">{{ item.totalValue }}</span>
    <span class="summary__cost">{{ item.totalCost | lcurrency: currencyCode }}</span>
  </div>
</div>

<ng-template #summaryTotalCostTooltip>
  <div class="tooltip__title">{{ 'settings.billingAdjustmentTitle' | translate }}</div>
  <div class="tooltip__descr">{{ 'settings.billingAdjustmentDescription' | translate: { value: (currencyCode === 'R$' ? '99.00' : '19.00') | lcurrency: currencyCode } }}</div>
</ng-template>
